import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { delete_icon, edit_icon, search_icon, toggle_off, toggle_on, view_icon } from '../../assets/imgs';
import { useNavigate } from 'react-router-dom';
import { useRolesListDeleteMutation, useRolesListMutation } from '../redux/api/api';
import { toast } from 'react-toastify';


const Role = () => {
    const navigate = useNavigate();
    const [deletePopup, setDeletePopup] = useState(false);
    const [list, setList] = useState([]);
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [count, setCount] = useState()

    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const [rolesListApi] = useRolesListMutation();
    const [rolesListDelete] = useRolesListDeleteMutation();




    const rolesList = (page, search) => {
        const formdata = new FormData();
        formdata.append("page", page)
        formdata.append("row", 10)
        if (search) {
            formdata.append('search', search)
        }
        rolesListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.admins?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setCount(res?.pagination?.toal)
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }
    const rolesDelete = (id) => {
        const formdata = new FormData();
        formdata.append("_method", "DELETE")

        rolesListDelete({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                if (res?.status == "success") {
                    setDeletePopup(false)
                    toast.success(res?.message);
                    rolesList();
                } else {
                    toast.error(res?.message);
                    setDeletePopup(false);
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        rolesList(pageno)
    }, [pageno]);

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Role",
                accessor: "role",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },

            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-ROLE') &&
                                    <button
                                        onClick={() => navigate("/add-role", { state: { type: "view", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                                {rolePermissions?.includes('CAN-EDIT-ROLE') &&
                                    <button
                                        onClick={() => navigate("/add-role", { state: { type: "edit", id: row.original.id } })}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                                {rolePermissions?.includes('CAN-DELETE-ROLE') &&
                                    <button
                                        onClick={() => setDeletePopup(row.original.id)}
                                        className="cust-btn "
                                    >
                                        <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                            </div>
                        </React.Fragment >
                    );
                },
            },
        ],
        []
    );
    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Roles List
                </h2>
                <div className='d-flex gap-3'>
                    < div className='search-input'>
                        <input onChange={(e) => rolesList(1, e.target.value)} type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
                        <img src={search_icon} className='search' />
                    </div>
                    {rolePermissions?.includes('CAN-ADD-ROLE') &&
                        <button onClick={() => navigate('/add-role', { state: { type: "add" } })} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add Role</button>}
                </div>
            </div>
            {deletePopup && (
                <div className='img-popup-design'>
                    <div className='img-popup'>
                        <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
                            Are you sure, want to Delete?
                        </p>
                        <div className="d-flex ac-jb px-2 mt-5">
                            <button onClick={() => setDeletePopup(false)} className="no-btn">
                                No
                            </button>
                            <button onClick={() => { rolesDelete(deletePopup); }} className="yes-btn f2" >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />

        </div>
    )
}

export default Role